import React, { useState, useEffect } from "react";
import Autocomplete from "react-autocomplete";
import { Controller } from "react-hook-form";
import CustomerApi from "../../../service/customerApi";

export const AutoCompleteChuNho = ({
  CustomerID,
  CustomerName,
  IsEditCustomer,
  control,
  updateChuNoSelect,
  chunovalue,
  updateChuNo,
}) => {
  const [value, setValue] = useState("");
  const [autocompleteData, setAutocompleteData] = useState([]);
  const [showClear, setShowClear] = useState(false);
  useEffect(() => {
    //alert('hehe');
    async function fetchMyAPI() {
      const tukhoa = {
        tuKhoa: "",
      };
      const response = await CustomerApi.AutocompleteChuNo.call(null, tukhoa);
      //alert(response);
      setAutocompleteData(response.data);
    }
    fetchMyAPI();
  }, []);

  const register = () => {};

  const onChangeCustomerText = (field) => (event) => {
    CustomerApi.AutocompleteChuNo(event.target.value);
  };
  const onSelectCustomer = (value, item) => {
    // setValue(value);
    const initChuno = {
      CustomerId: item.CustomerID,
      Address: item.Address,
      Phone: item.Phone,
      CustomerName: item.DinhDanh,
      IsEditCustomer: false,
    };
    IsEditCustomer=false;
    updateChuNoSelect(initChuno);
    setShowClear(true);
    setAutocompleteData([]);
  };

  const onChange = (field) => (e) => {
    updateChuNo({
      ...chunovalue,
      [field]: e.target.value,
    });
    async function fetchMyAPI() {
      const tukhoa = {
        tuKhoa: e.target.value,
      };
      const response = await CustomerApi.AutocompleteChuNo.call(null, tukhoa);
      setAutocompleteData(response.data);
    }
    fetchMyAPI();
  };

  const clearCustomer = () => () => {
    onChange("CustomerName", "");
    const initChuno = {
      CustomerId: 0,
      Address: "",
      Phone: "",
      CustomerName: "",
      IsEditCustomer: true,
    };
    IsEditCustomer=true;
    updateChuNoSelect(initChuno);
    setShowClear(false);
  };

 
  return (
    <>
      <input
        type="hidden"
        name="CustomerID"
        value={CustomerID}
        ref={register}
      ></input>
      <input
        type="hidden"
        name="customer.CustomerID"
        value={CustomerID}
        ref={register}
      ></input>

      <div className="">
        <label className="label-control color7-bold">
          Họ Tên
          <span className="canh-bao-red">*</span>
        </label>
        <div className="">
            <Autocomplete
              wrapperProps={{}}
              wrapperStyle={{
                position: "relative",
                width: "100%",
              }}
              inputProps={{
                className: "form-control input-sm card-autocomplete",
                 readOnly: showClear,
              }}
              menuStyle={{
                borderRadius: "3px",
                boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                background: "rgba(255, 255, 255, 0.9)",
                padding: "2px 0",
                fontSize: "90%",
                position: "absolute",
                overflow: "auto",
                maxHeight: "150px", // TODO: don't cheat, let it flow to the bottom
                top: "0 !important",
                left: "0 !important",
                zIndex: "1000",
              }}
              getItemValue={(item) => item.DinhDanh}
              items={autocompleteData}
              renderItem={(item, isHighlighted) => {
                return (
                  <div
                    className="auto-list"
                    style={{
                      background: isHighlighted ? "lightgray" : "white",
                      textTransform: "capitalize",
                    }}
                  >
                    {item.DinhDanh}
                  </div>
                );
              }}
              value={chunovalue.CustomerName}
              onSelect={(value, item) => {
                onSelectCustomer(value, item);
                //onChange();
              }}
              // onChange={(event, value) => {
              //   onChange(event, value);
              //   //onChangeCustomerText('CustomerName')(e);
              // }}
              onChange={onChange("CustomerName")}
            />
            {showClear && CustomerID !== 0 && (
              <button
                class="btn btn-default"
                onClick={clearCustomer()}
                style={{ position: "absolute", right: 0 }}
                type="button"
              >
                x
              </button>
            )}
        </div>
      </div>
    </>
  );
};
